import React, { useEffect } from 'react';
import { Box, TextField, FormControlLabel, Checkbox, Link, Typography } from '@mui/material';
import CustomButton from 'shared/custom-button/CustomButton';
import { colors } from 'app/providers/theme/colors-type';
import styles from 'features/health-ai/step-2/ui/InsuranceTermStep.module.css';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ru } from 'date-fns/locale';
import InfoIcon from '@mui/icons-material/Info';
import { useAppDispatch } from 'shared/utils/hooks/useRedux';
import { IStepTwo } from 'entities/health-ai/step-2/types/StepTwo-inerface';
import { updateField } from 'entities/health-ai/step-2';

interface InsuranceTermStepProps {
    formState: IStepTwo;
    errors: Record<string, string>;
    handleNextStep: () => void;
    handleBack: () => void;
    openDatePicker: boolean;
    setOpenDatePicker: (value: boolean) => void;
}

export const InsuranceTermStep: React.FC<InsuranceTermStepProps> = ({
    formState,
    errors,
    handleNextStep,
    handleBack,
    openDatePicker,
    setOpenDatePicker,
}) => {
    const localeText = {
        cancelButtonLabel: 'Отменить',
        okButtonLabel: 'ОК',
        toolbarTitle: 'Выберите дату начала',
    };
   
    const dispatch = useAppDispatch();
    return (
        <Box>

            <Box className={styles.dateBox}>
                <Box className={styles.titleBox}>
                    <h4>Срок действия полиса</h4>
                </Box>
                <Box className={styles.colorBox}>
                    <span className={styles.icon}><InfoIcon /></span>
                    <p>Полис начнет действовать не ранее, чем на 15-й день после даты заключения договора</p>
                </Box>
                <Box className={styles.fieldBox}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ru} localeText={localeText}>
                        <DatePicker
                            open={openDatePicker}
                            onClose={() => setOpenDatePicker(false)}
                            value={formState.BeginDate ? new Date(formState.BeginDate.split('.').reverse().join('-')) : null}
                            onChange={(newValue) => {
                                if (newValue) {
                                    const day = String(newValue.getDate()).padStart(2, '0');
                                    const month = String(newValue.getMonth() + 1).padStart(2, '0');
                                    const year = newValue.getFullYear();
                                    const formattedDate = `${day}.${month}.${year}`;
                                    dispatch(updateField({ field: 'BeginDate', value: formattedDate }));
                                } else {
                                    dispatch(updateField({ field: 'BeginDate', value: '' }));
                                }
                                setOpenDatePicker(false);
                            }}
                            minDate={new Date(Date.now() + 15 * 24 * 60 * 60 * 1000)}
                            maxDate={new Date(new Date().setMonth(new Date().getMonth() + 3))}
                            enableAccessibleFieldDOMStructure={false}
                            slots={{
                                textField: (params) => (
                                    <TextField
                                        {...params}
                                        label="Дата начала"
                                        variant="outlined"
                                        placeholder="дд.мм.гггг"
                                        onClick={() => setOpenDatePicker(true)}
                                        error={!!errors.BeginDate}
                                        helperText={errors.BeginDate}
                                        InputProps={{
                                            ...params.InputProps,
                                            readOnly: true,
                                        }}
                                        className={styles.roundedTextField}
                                    />
                                ),
                            }}
                            slotProps={{
                                toolbar: {
                                    hidden: true,
                                },
                            }}
                        />
                    </LocalizationProvider>
                    <TextField
                        name="EndDate"
                        label="Дата окончания"
                        variant="outlined"
                        value={formState.EndDate}
                        InputProps={{
                            readOnly: true,
                        }}
                        className={styles.roundedTextField}
                    />
                </Box>

            </Box>

            <Box className={styles.btnBoxNext}>
                <CustomButton
                    title="Назад"
                    handleClick={handleBack}
                    textColor={colors.primary}
                    backgroundColor="none"
                    width="150px"
                    gap="10px"
                    borderRadius='4px'
                    padding='3px'
                    border='none'
                />
                <CustomButton
                    title="Далее"
                    handleClick={handleNextStep}
                    textColor="white"
                    backgroundColor={colors.primary}
                    width="150px"
                    gap="10px"
                    borderRadius='4px'
                    padding='3px'
                />
            </Box>
        </Box>
    );
};
